import { Cta, Eyebrow, Reveal } from "@/components/landing/Shared";

export const MyStory = () => (
  <section className="bg-[var(--cream)] px-5 py-24 sm:px-8 lg:px-14 lg:py-32" data-testid="section-story">
    <div className="mx-auto grid max-w-6xl items-center gap-16 lg:grid-cols-2 lg:gap-20">
      <Reveal className="relative pb-24 pr-10 sm:pb-32 sm:pr-16">
        <img
          src="/photos/p5216.jpg"
          alt="Harley smiling while lying on a bed by a sunny window as her two daughters pile onto her back"
          loading="lazy"
          className="aspect-[4/3] w-full -rotate-2 rounded-3xl border-[6px] border-white object-cover object-[45%_65%] shadow-[0_30px_60px_-30px_rgba(38,65,67,0.5)]"
          data-testid="story-photo-1"
        />
        <img
          src="/photos/p5204.jpg"
          alt="Harley laughing on a white bed while her two young daughters kiss her on both cheeks"
          loading="lazy"
          className="absolute bottom-0 right-0 aspect-[3/4] w-[46%] rotate-3 rounded-3xl border-[6px] border-white object-cover object-[50%_75%] shadow-[0_30px_60px_-25px_rgba(38,65,67,0.55)]"
          data-testid="story-photo-2"
        />
      </Reveal>
      <div>
        <Reveal>
          <Eyebrow>My Story</Eyebrow>
          <h2 className="font-display text-4xl font-light leading-[1.1] tracking-tight sm:text-5xl" data-testid="story-heading">
            Hi, I'm <em className="text-[var(--mauve)]">Harley</em>
          </h2>
        </Reveal>
        <Reveal className="mt-8 space-y-5 text-base leading-relaxed text-[var(--muted)] sm:text-lg" >
          <p>I've been the mom standing at checkout when my card declined. I've had to push my cart to the side, with people around me, and sit in that uncomfortable moment when you don't know what to do next. I've been the mom who relied on government assistance.</p>
          <p className="font-semibold text-[var(--ink)]">That's why making $300 in my first week of getting started meant something to me. I'm still learning, growing, and figuring out what I can build from here, and my result isn't a promise of what someone else will earn.</p>
          <p>If you're tired of waiting on your ship to come in with no idea how to swim, this is your life boat.</p>
        </Reveal>
        <Reveal className="mt-10"><Cta testId="story-cta-button" label="I need this, show me how" href="#get-access" /></Reveal>
      </div>
    </div>
  </section>
);
